<template>
  <single-panel-page v-loading="!user.id">
    <h5>Set password</h5>

    <div
      v-for="error in errors.non_field_errors"
      :key="error"
      class="alert alert-danger alert-nobg text-left"
    >
      {{ error }}
    </div>
    <div
      v-show="!passwordChanged"
      class="form"
      :class="{ 'loader-cover': inProgress }"
    >
      <input
        v-model="newPassword"
        class="form-control"
        :class="{ 'has-errors': errors.new_password.length > 0 }"
        type="password"
        placeholder="New password"
        @keyup.enter="submit()"
      />
      <password :value="newPassword" />
      <p v-for="error in errors.new_password" :key="error" class="text-danger">
        {{ error }}
      </p>
    </div>
    <div v-show="passwordChanged" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-success">
          Your password has been updated
        </p>
      </div>
    </div>

    <TermsFormOrganizer
      v-if="user.isOrganizer"
      :all-terms-accepted.sync="allTermsAccepted"
      :show-errors="triedToSubmit"
    />

    <div class="row">
      <div class="col-sm-12 text-right">
        <button
          v-show="!passwordChanged"
          class="btn btn-block btn-primary text-uppercase"
          :disabled="inProgress"
          @click="submit()"
        >
          <span>Submit</span>
        </button>
      </div>
    </div>

    <div slot="bottom">
      <span class="splash-box-footer animated fadeIn">
        <router-link
          v-show="passwordChanged || errors.non_field_errors.length > 0"
          class="text-yellow"
          :to="dashboardRoute"
          >Back to app</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { mapGetters, mapState } from 'vuex'
import TermsFormOrganizer from '@/components/users/TermsFormOrganizer'

function getInitialErrors() {
  return { password: [], new_password: [], non_field_errors: [] }
}

export default {
  components: {
    TermsFormOrganizer,
  },
  data: function () {
    return {
      allTermsAccepted: false,
      triedToSubmit: false,
      newPassword: '',
      inProgress: false,
      errors: getInitialErrors(),
      passwordChanged: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user.data,
    }),
    ...mapGetters({
      dashboardRoute: 'user/dashboardRoute',
    }),
  },
  created() {
    this.$store.dispatch('user/getUser')
  },
  methods: {
    async submit() {
      this.triedToSubmit = true
      if (this.user.isOrganizer && !this.allTermsAccepted) {
        this.$message.error('Correct form errors')
        return
      }
      this.inProgress = true
      const newPassword = this.newPassword
      const data = { newPassword }
      const request = Auth.setNewPassword(data)
      try {
        const response = await request
        this.passwordChanged = true
        this.clearErrors()
        await this.$store.dispatch('user/refetchUser')
        this.$store.dispatch('user/goToDefaultPage')
        this.$message({
          type: 'success',
          title: 'Success',
          message: 'Password has been set',
        })
      } catch (error) {
        if (error.response) {
          // Object.assign(this.errors, error.response.data)
          this.errors = { ...this.errors, ...error.response.data }
        } else {
          throw error
        }
      } finally {
        this.inProgress = false
      }
    },
    clearErrors() {
      this.errors = getInitialErrors()
    },
  },
}
</script>

<style lang="scss" scoped>
.splash-box {
  .current-password {
    margin-bottom: 0px;
  }
  .forgot-password {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>
